import http from '../request/request.js';

export default {
  // 登录
  UsrLogin: function (params, apiType = 'pc') {
    return http.fetchPost('/Usr/UsrLogin', params, apiType);
  },

  // 修改密码
  UsrUpdPwd: function (params, apiType = 'pc') {
    return http.fetchPost('/Usr/UsrUpdPwd', params, apiType);
  },

  // 登出
  UsrLogout: function (params, apiType = 'pc') {
    return http.fetchPost('/Usr/UsrLogout', params, apiType);
  },
  // 修改订单上传信息
  updateHeartOrder: function (params, apiType = 'pc') {
    return http.fetchPost('/Record/Update', params, apiType);
  },
  // 删除订单
  delHeartOrder: function (params, apiType = 'pc') {
    return http.fetchPost('/Record/Delete', params, apiType);
  },
  // 订单信息导出
  ExportHeartOrderData: function (params, apiType = 'pc') {
    return http.fetchDownload('/Record/ExportHeartOrderData', params, apiType);
  },
  // 记录列表
  HeartRecordList: function (params, apiType = 'pc') {
    return http.fetchPost('/Record/OrderInfoList', params, apiType);
  },
  // 批量下载报告
  BulkDownloadReports: function (params, apiType = 'pc') {
    return http.fetchDownload('/Record/BulkDownloadReports', params, apiType);
  },
  // 获取枚举常量
  GetConst: function (params, apiType = 'pc') {
    return http.fetchPost('/Const/GetConst', params, apiType);
  },
  // 项目列表
  ManagerProjectList: function (params, apiType = 'pc') {
    return http.fetchPost('/Project/ProjectList', params, apiType);
  },
  // 驳回原因
  BackReason: function (params, apiType = 'pc') {
    return http.fetchPost('/Record/BackReason', params, apiType);
  },
  // 订单统计（今日数据）：单接口按当天时间范围返回各类型总数，后端实现
  HeartRecordStat: function (params, apiType = 'pc') {
    return http.fetchPost('/Record/OrderStat', params, apiType);
  }
};



// WEBPACK FOOTER //
// ./src/service/ApiService.js